import { type DependencyList, useCallback, useRef } from "react";

export function useDebouncedCallback<F extends (...args: any) => any>(
  fn: F,
  deps: DependencyList,
  delayMs: number
) {
  const timeout = useRef<NodeJS.Timeout | undefined>(undefined);

  // biome-ignore lint/correctness/useExhaustiveDependencies: the deps to fn are passed in
  const callbackFunction = useCallback(
    (...args: Parameters<F>) => {
      const setTimeoutCallback = () => {
        clearTimeout(timeout.current);
        fn(...args);
      };

      clearTimeout(timeout.current);
      timeout.current = setTimeout(setTimeoutCallback, delayMs);
    },
    [...deps, delayMs]
  );
  return callbackFunction;
}
